const brand = process.env.brand || 'default';

if (brand === 'nissan'){
  const en = require('./nissan/en');
  const es = require('./nissan/es');
  const allLanguages = {
    en,
    es,
  };

  const language = process.env.lang || 'en';
  module.exports = allLanguages[language];
} else if (brand === 'infiniti') {
  module.exports = require('./infiniti/en');
} else if (brand === 'default') {
  module.exports = require('./default/en');
}




// WEBPACK FOOTER //
// ./i18n/index.js